import { PropType } from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import _ from 'lodash'
import { faLock, faLockOpen, faCircleNotch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

import { SEARCH_TYPES } from '@skinsoft/const'
import { ItemTypeWrapper, SearchResult } from '@skinsoft/types'

import { ContainerDataStore } from '@skinsoft/entity/src/container'
import { MOVEMENT_ITEM_CARD_LOCATION_CHANGED, UPDATE_ITEM_MOVEMENT_PAGE } from '@skinsoft/events'

import { ReactiveVue } from '@skinsoft/reactive-vue'
import { ItemCard, SearchResultItemCard } from '@skinsoft/ui'
import { MovementItemCard } from '../movement-item-card'

require('./container-card.scss')

declare const ITEM_SEARCH_TYPES: string[]

const defaultSortFunction = (items: ItemTypeWrapper[]): ItemTypeWrapper[] => {
    return _.cloneDeep(items)
}

@Component({
    components: {
        sMovementItemCard: MovementItemCard,
        sItemCard: ItemCard,
        sSearchResultItemCard: SearchResultItemCard,
    },
    props: {
        container: {},
        inMovementDisplay: {},
        displayType: {},
        canDelete: {},
        sortFunction: {
            type: Function as PropType<(items: ItemTypeWrapper[]) => ItemTypeWrapper[]>,
            default: defaultSortFunction,
        },
    },
    name: 's-container-card',
    template: require('./container-card.html'),
})
export class ContainerCard extends ReactiveVue {
    private container: ItemTypeWrapper
    private inMovementDisplay: boolean
    private displayType: boolean
    private canDelete: boolean
    private sortFunction: (items: ItemTypeWrapper[]) => ItemTypeWrapper[]

    private subItems: ItemTypeWrapper[] = []
    private subContainers: ItemTypeWrapper[] = []
    private subAccessories: ItemTypeWrapper[] = []

    private sortedSubItems: ItemTypeWrapper[] = []
    private sortedSubContainers: ItemTypeWrapper[] = []
    private sortedSubAccessories: ItemTypeWrapper[] = []

    private isFetchingContent: boolean = false
    private contentFetched: boolean = false
    private isBeingDeleted: boolean = false
    private deleting: boolean = false

    private $containerDataStore: ContainerDataStore

    private closedContainerIcon = faLock
    private openedContainerIcon = faLockOpen
    public loadingIcon = faCircleNotch
    public checkIcon = faCheck
    public crossIcon = faTimes

    private MOVEMENT_ITEM_CARD_LOCATION_CHANGED = MOVEMENT_ITEM_CARD_LOCATION_CHANGED
    private UPDATE_ITEM_MOVEMENT_PAGE = UPDATE_ITEM_MOVEMENT_PAGE

    private mounted() {
        this.$root.$on('bv::collapse::state', (collapseId, isShown) => {
            // @ts-ignore
            if(collapseId && collapseId === this.container.item.id) {
                this.onToggleContent(isShown)
            }
        })
    }

    private fetchContent() {
        let searchTypes = _.uniq(ITEM_SEARCH_TYPES.concat([SEARCH_TYPES.physicalAccessoryItem, SEARCH_TYPES.physicalContainerItem]))
        this.isFetchingContent = true
        this.$containerDataStore
            // @ts-ignore 
            .getAssociatedItems(this.container.item.id, searchTypes)
            .subscribe(items => {
                    this.subContainers = []
                    this.subItems = []
                    this.subAccessories = []

                    for(const item of items) {
                        switch((item as SearchResult).entityType) {
                            case 'physicalContainerItem':
                                this.subContainers.push({
                                    item: item,
                                    itemType: 'Container',
                                    wrapperType: 'SearchResult',
                                })
                                continue
                            case 'physicalAccessoryItem':
                                this.subAccessories.push({
                                    item: item,
                                    itemType: 'Accessory',
                                    wrapperType: 'SearchResult',
                                })
                                continue
                            default:
                                this.subItems.push({
                                    item: item,
                                    itemType: 'Item',
                                    wrapperType: 'SearchResult',
                                })
                                continue
                        }
                    }

                    this.applySort()
                    
                    this.contentFetched = true
                    this.isFetchingContent = false
            })
    }

    private applySort() {
        this.sortedSubItems = this.sortFunction(this.subItems)
        this.sortedSubContainers = this.sortFunction(this.subContainers)
        this.sortedSubAccessories = this.sortFunction(this.subAccessories)
    }

    private get containerIcon() {
        // @ts-ignore we consider that this.container is indeed a container (either Container or SearchResult)
        if (this.container.item.containerItemSchema.openContainer) {
            return this.openedContainerIcon
        }

        // @ts-ignore we consider that this.container is indeed a container (either Container or SearchResult)
        if (this.container.item.containerItemSchema.openContainer === false) {
            return this.closedContainerIcon
        }
    }

    private onToggleContent(contentShown: boolean) {
        if(!this.contentFetched && contentShown) {
            this.fetchContent()
        }
    }

    private onLongPress() {
        if(this.canDelete) {
            this.isBeingDeleted = !this.isBeingDeleted
        }
    }

    private onDelete() {
        this.deleting = true
        this.$emit('delete', this.container)
    }

    private onCancelDelete() {
        this.isBeingDeleted = false
    }

    @Watch('container')
    private onContainerChanged() {
        this.isBeingDeleted = false
    }

    @Watch('sortFunction')
    private onSortFunctionChanged() {
        this.applySort()
    }
}
